<template>
  <v-container fluid class="tournaments-list">
    <loader :show="$anyLoading()" :message="messageLoader"></loader>
    <confirm-modal
      :dialog="showConfirm"
      :message="confirmMessage"
      @confirm="confirmResponse($event)"></confirm-modal>
    <v-layout row wrap>
      <v-flex xs6 md5 offset-md1 d-flex align-center>
        <h5 class="green--text mb-0">Torneos</h5>
      </v-flex>
      <v-flex xs6 md5 text-xs-right>
        <v-tooltip left>
          <v-btn
            dark
            color="green"
            slot="activator"
            fab
            small
            @click="goNewTournament">
              <v-icon>add</v-icon>
            </v-btn>
          <span>Nuevo Torneo</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1>
        <v-text-field
          v-model="tableFilter"
          box
          name="searchbar"
          label="Buscar torneos"
          append-icon="search"
          class="white--text"></v-text-field>
      </v-flex>

      <v-flex xs12 md10 offset-md1>
        <v-data-table
          :rows-per-page-items="[25,50,100]"
          :search="tableFilter"
          :headers="headers"
          :items="tournaments"
          class="elevation-1 responsive-table"
          light
          :loading="tableLoading"
          rows-per-page-text="Filas por página"
          >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left green--text sticky-cell"
              @click="goEditTournament(props.item.id)">
              <v-flex no-wrap class="crop-text">
                <strong class="cursor-pointer" v-html="props.item.name"/>
                <v-tooltip right>
                  <span slot="activator">
                  <v-chip
                    v-if="props.item.totalAccessPetitions > 0"
                    label
                    small
                    color="green lighten-4"
                    class="ml-2">
                      {{ props.item.totalAccessPetitions }}
                    </v-chip>
                    </span>
                  <span>Solicitudes de acceso</span>
                </v-tooltip>
              </v-flex>

            </td>
            <td class="text-xs-left">{{ props.item.startDate }}</td>
            <td class="text-xs-left">{{ props.item.endDate }}</td>
            <td class="text-xs-left">{{props.item.scheduleMatches}}</td>
            <td v-if="props.item.status == 'finalized' " class="text-xs-left">Finalizado</td>
            <td v-if="props.item.status != 'finalized' " class="text-xs-left grey--text">
              <v-tooltip left>
                <v-switch

                  v-model="props.item.status === 'active'"
                  light
                  color="green"
                  slot="activator"
                  @click="disableTournament($event, props.item)" >
                  </v-switch>
                  <span>{{ props.item.status === 'active' ? 'Activo' : 'Pausado' }}</span>
              </v-tooltip>
            </td>
            <td>
              <v-btn v-if="props.item.registries" @click="goTournamentRegistrations(props.item.id)" color="primary">Solicitudes</v-btn>
            </td>

          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Utils from '@/utils/utils'

export default {
  name: "Players",
  data: () => ({
    messageLoader: 'Cargando Torneos...',
    tableFilter: '',
    seeDisabledTournaments: false,
    actionSelected: '',
    tournamentSelected: [],
    showConfirm: false,
    confirmMessage: '¿Estas seguro que quieres inhabilitar el torneo?',
    players: [],
    // Muestra un pequeño loading encima de la tabla dependiendo de su valor (True, False)
    tableLoading: false,
    headers: [
      { text: 'Nombre', value: 'name', align: 'left' },
      { text: 'Inicio', value: 'startDate', align: 'left' },
      { text: 'Fin', value: 'endDate', align: 'left' },
      { text: 'Partidos Agendados', value: 'scheduledGames', align: 'left' },
      { text: 'Estado', value: 'status', align: 'left' },
      { text: 'Acciones', value: '', align: 'left' },
    ],
    items: [
      {
        value: false,
        name: 'Copa Tecate',
        startDate: new Date().toString('y-m-d'),
        endDate: new Date().toString('y-m-d'),
        scheduledGames: 10,
        status: true
      },
      {
        value: false,
        name: 'Copa Tecate',
        startDate: new Date().toString('y-m-d'),
        endDate: new Date().toString('y-m-d'),
        scheduledGames: 10,
        status: false
      }
    ]
  }),
  mounted() {
    this.loadTournaments()
    Utils.setTableOverflowClass('.responsive-table');
  },
  computed: {
    ...mapGetters([
      'tournaments',
    ]),
    ...mapGetters('loading', [
      'isLoading',
      'anyLoading',
    ])
  },
  methods: {
    ...mapActions([
      'loadTournaments',
      'goNewTournament',
      'goEditTournament',
      'goTournamentRegistrations',
      'pauseTournament'
    ]),
    disableTournament(event, tournament) {
      this.actionSelected = 'disableTournament'
      this.tournamentSelected = tournament
      let msg1 = '¿Estas seguro que quieres inhabilitar el torneo?'
      let msg2 = '¿Estas seguro que quieres habilitar el torneo?'

      this.confirmMessage = tournament.status == "active" ? msg1 : msg2
      this.showConfirm = true
    },

    confirmResponse(response) {
      if(response){
        //En caso la respuesta del usuario sea positiva
        if(this.actionSelected === 'disableTournament')
          this.pauseTournament(this.tournamentSelected)
      }else {
        //En caso la respuesta del usuario sea negativa
      }
      this.showConfirm = false
    }
  }
}
</script>

<style lang="scss">
@import "src/assets/scss/tables-placeholder-selectors";

.tournaments-list {
  th:first-child,
  .sticky-cell {
    @extend %sticky-cell;
    top: auto;
    left: 0;
  }

  .has-scroll th:first-child,
  .has-scroll .sticky-cell {
    @extend %sticky-cell-has-shadow;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/tournaments.vue